<template>
  <div class="message-list mt-4">
    <div
      v-for="(message, k) in messages"
      :key="message.id"
      :id="'message-' + message.id"
    >
      <div v-if="!isNotificationType(message.meta.type)">
        <div
          class="d-flex align-center justify-center mb-4 text-body-1 secondary-font grey--text text--darken-2"
          v-if="showDate(message.createdAt, k)"
        >
          {{ $moment(message.createdAt).format("dddd DD MMM YYYY") }}
        </div>
        <div
          class="d-flex flex-row align-center mb-4 message-hover-wrapper"
          :class="{ 'flex-row-reverse mr-5': message.direction === 'OUT' }"
        >
          <div
            :class="{
              'mr-2': message.direction === 'IN',
              'ml-2': message.direction === 'OUT',
            }"
          >
            <message-list-avatar
              :type="conversation.channel.type"
              color="primary"
              :author="message.authorId"
            ></message-list-avatar>
          </div>

          <div
            class="position-relative d-flex align-center"
            :class="{
              'message-list-content-50': $vuetify.breakpoint.mdAndUp,
              'message-list-content-85': $vuetify.breakpoint.smAndDown,
            }"
          >
            <!-- Contenu du message -->
            <message-list-content
              :content="message.content"
              :direction="message.direction"
              :meta="message.meta"
              :loading="message.loading"
              :status="message.status"
              :created-at="message.createdAt"
              :error="message.error"
              :conversation="conversation"
              :is-fetching="message.isFetching || false"
              :is-loaded="message.isLoaded || false"
              :media-properties="
                message.mediaProperties || {
                  url: null,
                  mimetype: null,
                  size: null,
                }
              "
              @fetch-media="handleFetchMedia(k)"
            ></message-list-content>

            <!-- Bouton d'action au survol -->
            <div v-if="message.direction === 'OUT'" class="message-actions">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    class="action-btn"
                  >
                    <v-icon small color="grey darken-1"
                      >mdi-dots-vertical</v-icon
                    >
                  </v-btn>
                </template>
                <v-list dense class="pa-0">
                  <v-list-item
                    @click="$emit('deleteMessage', message)"
                    class="red--text"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon small color="error">mdi-delete-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{
                      $t("btn.delete") || "Supprimer"
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex align-center justify-center mb-4">
        <message-list-notification
          :meta="message.meta"
          :created-at="message.createdAt"
          :author-id="message.authorId"
        ></message-list-notification>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-list {
  &-content {
    &-50 {
      max-width: 50%;
    }
    &-85 {
      max-width: 85%;
    }
  }
}
.message-hover-wrapper {
  .message-actions {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    margin-right: 4px;
    margin-left: 4px;
  }

  &:hover {
    .message-actions {
      opacity: 1;
    }
  }
}
</style>

<script>
import MessageListNotification from "./message-list-notification.vue";
import MessageListContent from "./message-list-content.vue";
import MessageListAvatar from "./message-list-avatar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    messages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    conversation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    isNotificationType(type) {
      return this.notficationTypes.includes(type);
    },
    showDate(createdAt, index) {
      if (index > 0) {
        return !this.$moment(createdAt).isSame(
          this.$moment(this.messages[index - 1].createdAt),
          "day",
        );
      }
      return true;
    },

    async handleFetchMedia(index) {
      const message = this.messages[index];
      const mediaId = message?.meta?.extra?.media_id;

      if (!mediaId) return;

      if (message.error) return ;

      this.$set(message, "isFetching", true);

      try {
        const resp = await this.request({
          url: `conversation/messages.media/${mediaId}/msg_id/${message.id}`,
          responseType: "blob",
        });

        const blob = resp.data;

        if (!(blob instanceof Blob)) {
          throw new Error("Response is not a blob");
        }

        const objectUrl = URL.createObjectURL(blob);

        this.$set(message, "mediaProperties", {
          url: objectUrl,
          mimetype: blob.type,
          size: blob.size,
        });

        this.$set(message, "isLoaded", true);
      } catch (error) {
        //
      } finally {
        this.$set(message, "isFetching", false);
      }
    },
    ...mapActions({
      notify: "notification/notify",
      closeNotify: "notification/close",
      request: "request",
    }),
  },
  components: {
    MessageListAvatar,
    MessageListContent,
    MessageListNotification,
  },
  computed: {
    ...mapGetters({ notficationTypes: "message/notificationTypes" }),
  },
};
</script>
